export const uploadFileToS3 = async (file: File, uploadUrl: string): Promise<void> => {
  const uploadResponse = await fetch(uploadUrl, {
    method: 'PUT',
    body: file,
    headers: {
      'Content-Type': file.type,
      'x-amz-server-side-encryption': 'AES256',
    },
    credentials: 'omit', // Don't send credentials to S3
  });

  if (!uploadResponse.ok) {
    throw new Error(`Failed to upload file to S3: ${uploadResponse.statusText}`);
  }
};
